module.exports = __webpack_public_path__ + "rHcc7iSXLXa-OOVBKYktooX0hVgzZQUfRDuZrPvH3D8.035d0f4a677c41e25dee.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/rHcc7iSXLXa-OOVBKYktooX0hVgzZQUfRDuZrPvH3D8.woff2
// module id = ../../../../../src/assets/fonts/font-google/rHcc7iSXLXa-OOVBKYktooX0hVgzZQUfRDuZrPvH3D8.woff2
// module chunks = 40